module.exports = __webpack_public_path__ + "static/goodrich-bg-746ecfa7369bcdb8aa766b62fcaf613c.mp4";